module.exports = __webpack_public_path__ + "static/media/dashboard.bd01105d.svg";